module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "food-search-dialog"
  }, [_c('mu-content-block', {
    staticClass: "blueHeader"
  }, [_c('mu-flexbox', [_c('mu-flexbox-item', [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('md-icon', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "slot": "default"
    },
    domProps: {
      "textContent": _vm._s('close')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeDialog('addFoodDialog')
      }
    },
    slot: "default"
  })], 1)], 1)], 1), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('mu-paper', {
    staticClass: "search-area"
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "grow": "7",
      "shrink": "7"
    }
  }, [_c('mu-text-field', {
    attrs: {
      "icon": "search",
      "hintText": _vm.$t('message.searchText'),
      "underlineShow": false,
      "hintTextClass": "hidden",
      "fullWidth": ""
    },
    model: {
      value: (_vm.searchValue),
      callback: function($$v) {
        _vm.searchValue = $$v
      },
      expression: "searchValue"
    }
  })], 1), _vm._v(" "), (_vm.voiceSupported) ? _c('mu-flexbox-item', {
    attrs: {
      "shrink": "1",
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "icon": "keyboard_voice"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startVoiceRecognition.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "scrollable-area"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isSearching) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 24
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [(_vm.isListening) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('div', {
    staticClass: "load-wrapp"
  }, [_c('div', {
    staticClass: "load-3 bottom"
  }, [_c('div', {
    staticClass: "line loaderRed"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderGreen"
  }), _vm._v(" "), _c('div', {
    staticClass: "line loaderBlue"
  })]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.labelVoiceRecognition')) + "\n          ")]), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "Stop"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.stopVoiceRecognition()
      }
    }
  })], 1)]) : _vm._e()], 1), _vm._v(" "), (!_vm.isListening) ? _c('mu-list', {
    staticClass: "oddEven"
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('mu-list-item', {
      key: 'suggestion-' + index,
      attrs: {
        "disableRipple": ""
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleSelection(suggestion)
        }
      }
    }, [_c('mu-icon', {
      attrs: {
        "slot": "left",
        "value": "search"
      },
      slot: "left"
    }), _vm._v(" "), _vm._o(_c('div', {
      attrs: {
        "slot": "title"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.highlight(suggestion)))
      },
      slot: "title"
    }), 0, 'suggestion-' + index)], 1)
  }), 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d136f13","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDiary/AutocompleteDialog/AutocompleteDialog.vue
// module id = 3769
// module chunks = 1